<script setup>
const content = `De schaal Invloed omschrijft de mate waarin iemand goed in staat is de leiding te nemen en invloed uit te oefenen op anderen. <br> Mensen die hierop hoog scoren zijn ambitieus en werken graag hun plannen op hun eigen manier uit. Ze zijn overtuigd van hun eigen mening en laten zich niet snel van hun stuk brengen. <br> Iemand die laag scoort op deze schaal zet zichzelf minder op de voorgrond en hoeft niet zonodig altijd het uiterste te bereiken.`
</script>

<template>
  <div class="">
    <InfoTippy :content />
  </div>
</template>
